import { gql } from '__generated__'

/**
 * Stores the cookie choice of the current user or guest session (FE-330).
 * Until the backend has it, nothing is delivered to GA4 or Meta.
 */
export const UPDATE_ANALYTICS_CONSENT = gql(`
  mutation updateAnalyticsConsent($input: UpdateAnalyticsConsentInput!) {
    updateAnalyticsConsent(input: $input)
  }
`)
